








































































































































































































import Vue, { PropType } from "vue";
import LocalePrice from "@/lib/localePrice";
import Locale from "@/lib/locale";
import { TextContainsLink as VcTextContainsLink } from "@/components";
import VcPlanOptionCreditCardIconForMonthly from "@/components/PlanOptionDetail/PlanOptionCreditCardIconForMonthly.vue";
import VcPlanOptionStoreAndBankIconForMonthly from "@/components/PlanOptionDetail/PlanOptionStoreAndBankIconForMonthly.vue";

export interface PlanOptionDetailProps {
  lang: any;
  paymentLang: any;
  link: string;
  target: string;
  price: string;
  defaultCurrency: string;
  buttonMoreDetails: string;
  isShowPlanList: boolean;
  planListLink: string;
  planListText: string;
  payWithPaypalLink: string;
  payWithPaypalText: string;
  isIce: boolean;
  planKey: string;
  detailReplaceLink: any;
  assetsOfferLink: string;
  assetsIcScreenLink: string;
  cloudPlanLink: string;
  offersLink: string;
}
export interface PlanOptionDetailData {
  showDetail: boolean;
  priceText: string;
  locale: string;
}

export default Vue.extend({
  name: "vc-plan-option-detail",
  components: {
    VcPlanOptionStoreAndBankIconForMonthly,
    VcPlanOptionCreditCardIconForMonthly,
    VcTextContainsLink
  },
  data(): PlanOptionDetailData {
    return {
      showDetail: false,
      priceText: this.lang.note_price,
      locale: Locale.getLocale()
    };
  },
  props: {
    lang: {
      type: Object as PropType<PlanOptionDetailProps["lang"]>,
      default: () => ({})
    },
    paymentLang: {
      type: Object as PropType<PlanOptionDetailProps["paymentLang"]>,
      default: () => ({})
    },
    link: {
      type: String as PropType<PlanOptionDetailProps["link"]>,
      default: ""
    },
    target: {
      type: String as PropType<PlanOptionDetailProps["target"]>,
      default: ""
    },
    price: {
      type: String as PropType<PlanOptionDetailProps["price"]>,
      default: ""
    },
    defaultCurrency: {
      type: String as PropType<PlanOptionDetailProps["defaultCurrency"]>,
      default: ""
    },
    buttonMoreDetails: {
      type: String as PropType<PlanOptionDetailProps["buttonMoreDetails"]>,
      default: ""
    },

    isShowPlanList: {
      type: Boolean as PropType<PlanOptionDetailProps["isShowPlanList"]>,
      default: false
    },
    planListLink: {
      type: String as PropType<PlanOptionDetailProps["planListLink"]>,
      default: ""
    },
    planListText: {
      type: String as PropType<PlanOptionDetailProps["planListText"]>,
      default: ""
    },
    payWithPaypalLink: {
      type: String as PropType<PlanOptionDetailProps["payWithPaypalLink"]>,
      default: ""
    },
    payWithPaypalText: {
      type: String as PropType<PlanOptionDetailProps["payWithPaypalText"]>,
      default: ""
    },
    isIce: {
      type: Boolean as PropType<PlanOptionDetailProps["isIce"]>,
      default: false
    },
    planKey: {
      type: String as PropType<PlanOptionDetailProps["planKey"]>,
      default: ""
    },
    detailReplaceLink: {
      type: Object as PropType<PlanOptionDetailProps["detailReplaceLink"]>,
      default: () => ({})
    },
    assetsOfferLink: {
      type: String as PropType<PlanOptionDetailProps["assetsOfferLink"]>,
      default: ""
    },
    assetsIcScreenLink: {
      type: String as PropType<PlanOptionDetailProps["assetsIcScreenLink"]>,
      default: ""
    },
    cloudPlanLink: {
      type: String as PropType<PlanOptionDetailProps["cloudPlanLink"]>,
      default: ""
    },
    offersLink: {
      type: String as PropType<PlanOptionDetailProps["offersLink"]>,
      default: ""
    }
  },
  computed: {
    isUpdatepass(): boolean {
      return (
        this.planKey === "pro_updatepass" || this.planKey === "ex_updatepass"
      );
    },
    isPayableWithPaypal(): boolean {
      // 日本以外、かつ、アップデートプランの場合は PayPal で支払い可能
      return this.locale !== "ja-jp" && this.isUpdatepass;
    }
  },
  mounted() {
    this.priceText = this.lang.note_price.replace(
      ":price",
      LocalePrice.getPrice(Locale.getLocale(), Number(this.price))
    );
  },
  methods: {
    async changeShowDetail() {
      this.showDetail = true;
    }
  }
});
